import { LogError } from "../../../helpers/logger"

export async function handleParticipantNavigateEvent(
  actionUrl,
  notification,
  userCtx,
  navigate
) {
  try {
    let parsedPayload, payloadString, participantId, targetLocation

    if (actionUrl === notification?.primaryActionUrl) {
      payloadString = notification?.primaryActionPayload
    } else if (actionUrl === notification?.secondaryActionUrl) {
      payloadString = notification?.secondaryActionPayload
    } else {
      LogError("Unknown actionUrl for ParticipantNavigate event")
      return
    }

    if (!payloadString) {
      LogError("Payload is missing for ParticipantNavigate event")
      return
    }

    parsedPayload = JSON.parse(payloadString)

    if (parsedPayload) {
      participantId = parsedPayload?.participant_id
      targetLocation = parsedPayload?.navigate

      if (participantId && targetLocation) {
        //If the participant is not the current participant, switch to that participant first
        if (userCtx.current_participant_id !== participantId) {
          await userCtx.changeParticipant(participantId)
        }

        //navigate to the target location
        navigate(targetLocation)
      } else {
        LogError(
          "payload missing participant_id or navigate property",
          parsedPayload
        )
      }
    }
  } catch (error) {
    LogError("Error handling ParticipantNavigate event", error)
  }
}
